import { isValid } from "date-fns";

import { formatDistance } from "@/helpers/date";
import { useTranslation } from "@/translations";

type LastActivityLabelProps = {
  lastActivityAt: string | undefined;
  showNoActivity?: boolean;
};

export const LastActivityLabel = ({
  lastActivityAt,
  showNoActivity = false,
}: LastActivityLabelProps): React.ReactNode => {
  const { t } = useTranslation();

  let date: Date | undefined;
  if (!lastActivityAt) {
    date = undefined;
  } else if (isValid(new Date(lastActivityAt))) {
    date = new Date(lastActivityAt);
  }

  if (!date) {
    if (showNoActivity) {
      return <span className="text-caption text-text-secondary">{t("common.label.no-activity")}</span>;
    }

    return null;
  }

  return (
    <time className="text-caption text-text-secondary">
      {t("common.label.last-activity", {
        time: formatDistance(t, { start: date }),
      })}
    </time>
  );
};
